import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=a587833c&scoped=true&"
import script from "./cashier.vue?vue&type=script&lang=js&"
export * from "./cashier.vue?vue&type=script&lang=js&"
import style0 from "./cashier.vue?vue&type=style&index=0&id=a587833c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a587833c",
  null
  
)

export default component.exports